import { useState, useMemo } from "react";
import { IoSearch } from "react-icons/io5";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { ChevronDownIcon } from "lucide-react";
import { PiBarcode, PiPackageLight } from "react-icons/pi";

const SearchBar = ({onSearch = () => {}}) => {
  const [value, setValue] = useState("");
  const options = useMemo(
    () => [
      { label: "AWB", icon: PiBarcode, placeholder: "Search multiple AWBs", value: "awbs" },
      { label: "Order ID", icon: PiPackageLight, placeholder: "Search multiple Order IDs", value: "orderId" },
    ],
    []
  );
  const [selected, setSelected] = useState(options[0]);

  const handleSearch = () => {
    onSearch(selected.value, value);
  };

  return (
    <div className="flex gap-2 w-full flex-1 max-w-[620px] h-full max-h-12 bg-background_2 p-1 rounded-2xl">
      <SearchOption
        options={options}
        selected={selected}
        onClick={setSelected}
      />
      <input
        type="text"
        placeholder={selected.placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}  
        className="w-full bg-transparent text-body1 text-secondary/95 focus:outline-none placeholder:text-secondary/50"
      />
      <button
        onClick={handleSearch}
        className="flex items-center justify-center rounded-[14px] font-semibold font-nunito transition-colors flex-grow-0 group flex-shrink-0 bg-secondary/95 text-background/95 hover:bg-secondary/80 hover:text-background/70 pr-3 pl-1 py-2 text-base gap-[6px]"
      >
        <IoSearch className="h-8 w-8 rounded-[11px] bg-background/90 text-secondary/90 p-1.5 group-hover:bg-background/60 group-hover:text-secondary/70 transition-all" />
        Search
      </button>
    </div>
  );
};

const SearchOption = ({ options, onClick, selected }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="pl-2.5 min-w-20 pr-2 py-1 flex justify-between items-center bg-background/95 rounded-[14px]  gap-1 text-secondary/80 text-[14px] shrink-0 grow-0 hover:bg-secondary/20 transition">
          {selected.icon && selected.icon()}
          {selected.label}

          <ChevronDownIcon className="h-3 w-fit ml-1" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-1 w-full bg-background border border-secondary/20 rounded-xl shadow-lg overflow-hidden">
        <div className="flex flex-col gap-1">
          {options.map((option, index) => (
            <button
              key={index}
              onClick={() => onClick(option)}
              className="px-2 py-1 flex items-center gap-1 text-secondary/90 text-[14px] hover:bg-secondary/10 transition rounded-lg"
            >
              {option.icon && option.icon()}
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default SearchBar;
